import { GraphQLClient } from "graphql-request";
import queries from "./queries";
import config from "../../config";
import {generateHeaders, generateHeaderswithBasicAuthToken, generateEpochTimestamp, generateSignature} from "../../utils/helper";
let instance = null;

// let soundPlayStatus = Sound.status.STOPPED;
let soundPlayStatus = false;
let checkActiveOrders = false;
export default class requestManager {
  constructor() {
    if (!instance) {
      instance = this;
      this.client = null;
    }
    return instance;
  }
  getStoreDetails = async () => {
    let params = {};
    let response = await this.getResponseFromPredefinedQuery(
      "getUserProfile",
      params
    );
    console.log("getStoreDetails RM", JSON.stringify(response));
    if (response.error) {
      //alert('Something went wrong. Please try again later.')
    } else {
      let res = JSON.parse(JSON.stringify(response));

      if (res.data.userProfile.user.store === null) {
      } else {
        localStorage.setItem(
          "printRollChange",
          res.data.userProfile.user.store.printRollChange
        );
      }
    }
  };

  setCheckActiveOrders(val) {
    checkActiveOrders = val;
    return checkActiveOrders;
  }
  getSoundFile() {
    let sound = "bell";
    if (localStorage.getItem("sound") !== null) {
      sound = localStorage.getItem("sound");
    } else {
      localStorage.setItem("sound", sound);
    }
    return sound;
  }

  getCheckActiveOrders() {
    return checkActiveOrders;
  }

  getSound() {
    return soundPlayStatus;
  }
  setSound(val) {
    soundPlayStatus = val;
    return soundPlayStatus;
  }

  getResponseFromCustomQuery = async (
    queryName,
    parameters = {},
    token = null
  ) => {
    let url = config.getHost() + "/graph";

    if (token != null) {
      try {
        var vtimestamp = generateEpochTimestamp();    
        let tempClient = new GraphQLClient(url, {
          headers: {
            Authorization: `Token ${token}`,
            Timestamp: vtimestamp,
            Signature: generateSignature(vtimestamp, token)                  
          },
        });
        let response = await tempClient.request(queryName, parameters);
        return { data: response, error: null };
      } catch (error) {
        return { data: null, error: error };
      }
    } else {
      try {
        if (this.client === null) {
          // let storeInformation = JSON.parse(
          //   localStorage.getItem("storeInformation")
          // );
          // let gngtoken = JSON.parse(
          //   localStorage.getItem("gngtoken")
          // );
          // let authToken ;
          // if(storeInformation !== null)
          // authToken = storeInformation.token;
          // else{
          //   authToken = gngtoken;
          // }

          let storeInformation = JSON.parse(
            localStorage.getItem("storeInformation")
          );
          let authToken = storeInformation.token;

          this.authToken = authToken;
          var vtimestamp = generateEpochTimestamp();             
          this.client = new GraphQLClient(url, {
            headers: {
              Authorization: `Token ${authToken}`,
              Timestamp: vtimestamp,
              Signature: generateSignature(vtimestamp, authToken)                
            },
          });
        }
        let response = await this.client.request(queryName, parameters);
        return { data: response, error: null };
      } catch (error) {
        return { data: null, error: error };
      }
    }
  };

  getResponseFromPredefinedQuery = async (
    queryName,
    parameters = {},
    token = null
  ) => {
    let url = config.getHost() + "/graph";

    if (token != null) {
      try {
        var vtimestamp = generateEpochTimestamp();           
        let tempClient = new GraphQLClient(url, {
          headers: {
            Authorization: `Token ${token}`,
            Timestamp: vtimestamp,
            Signature: generateSignature(vtimestamp, token)              
          },
        });
        let response = await tempClient.request(queries[queryName], parameters);

        return { data: response, error: null };
      } catch (error) {
        return { data: null, error: error };
      }
    } else {
      try {
        if (this.client === null) {
          // let storeInformation = JSON.parse(
          //   localStorage.getItem("storeInformation")
          // );
          // let gngtoken = JSON.parse(
          //   localStorage.getItem("gngtoken")
          // );
          // let authToken ;
          // if(storeInformation !== null)
          // authToken = storeInformation.token;
          // else{
          //   authToken = gngtoken;
          // }

          let storeInformation = JSON.parse(
            localStorage.getItem("storeInformation")
          );
          let authToken = storeInformation.token;

          // console.log("authToken", authToken);
          // alert(JSON.stringify( authToken))
          // console.log("storeID",storeInformation.store.id)
          this.authToken = authToken;
          var vtimestamp = generateEpochTimestamp();             
          this.client = new GraphQLClient(url, {
            headers: {
              Authorization: `Token ${authToken}`,
              Timestamp: vtimestamp,
              Signature: generateSignature(vtimestamp, authToken)                
            },
          });
        }
        let response = await this.client.request(
          queries[queryName],
          parameters
        );
        return { data: response, error: null };
      } catch (error) {
        return { data: null, error: error };
      }
    }
  };

  getResponseForStaff = async (queryName, parameters = {}, token) => {
    let url = config.getHost() + "/graph";

    if (token !== null) {
      try {
        var vtimestamp = generateEpochTimestamp();           
        let tempClient = new GraphQLClient(url, {
          headers: {
            Authorization: `Token ${token}`,
            Timestamp: vtimestamp,
            Signature: generateSignature(vtimestamp, token)              
          },
        });
        let response = await tempClient.request(queries[queryName], parameters);

        return { data: response, error: null };
      } catch (error) {
        return { data: null, error: error };
      }
    } else {
      try {
        if (this.client === null) {
          var vtimestamp = generateEpochTimestamp();             
          this.client = new GraphQLClient(url, {
            headers: {
              Authorization: `Token ${token}`,
              Timestamp: vtimestamp,
              Signature: generateSignature(vtimestamp, token)                
            },
          });
        }
        let response = await this.client.request(
          queries[queryName],
          parameters
        );
        return { data: response, error: null };
      } catch (error) {
        return { data: null, error: error };
      }
    }
  };

  clearClient = () => {
    this.client = null;
  };
}



// WEBPACK FOOTER //
// ./src/singletons/RequestManager/RequestManager.js